<template>
    <b-container fluid class="mt--7">
        <b-card :title="title">
            <b-card-body>
                <b-table :items="items" :fields="fields">
                    <template #cell(control)="{ index, item }">
                        <b-button
                            v-if="index == items.length - 1"
                            variant="link"
                            @click="addFrequency(item)"
                            >Add
                        </b-button>
                        <b-button
                            v-else
                            variant="link"
                            @click="deleteNote(index)"
                            >Remove
                        </b-button>
                    </template>

                    <template #cell(name)="{ index, item, value }">
                        <b-form-input
                            v-if="index == items.length - 1"
                            :id="`input-name${index}`"
                            placeholder="name"
                            v-model="item.name"
                            type="text"
                        ></b-form-input>

                        <span v-else>{{ value }}</span>
                    </template>

                    <template #cell(value)="{ index, item, value }">
                        <b-form-input
                            v-if="index == items.length - 1"
                            :id="`input-value${index}`"
                            placeholder="Value"
                            v-model="item.value"
                            type="number"
                        ></b-form-input>

                        <span v-else>{{ value }}</span>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'AssetFrequencySettings',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        title: 'Asset Frequencies',
        fields: [
            'name',
            { key: 'value', label: 'Days(1-365)' },
            { key: 'control', label: '' },
        ],
        model: {
            frequencies: [],
        },
        updating: false,
    }),

    computed: {
        assetFrequencies() {
            const assetFrequencies =
                this.$store.getters['company/assetFrequencies']
            console.log('computed assetFrequencies', assetFrequencies)
            return assetFrequencies
        },
        items() {
            return [...this.model.frequencies, { name: '', value: '' }]
        },
        settingKeys() {
            return this.$store.state.company.settingKeys.assetFrequencyKey
        },
    },

    watch: {
        assetFrequencies: {
            handler: function (val) {
                console.log('watch assetFrequencies', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    async mounted() {
        console.log('this.settingKeys', this.settingKeys)
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.settingKeys
        )
        this.$nextTick(() => {
            this.updateModel(this.assetFrequencies)
        })
    },

    methods: {
        updateModel(assetFrequencies) {
            console.log('update point reached')
            console.log('update assetFrequencies', assetFrequencies)
            let frequencies = assetFrequencies.frequencies || []
            this.model = { frequencies }
            console.log('update model', this.model)
        },

        async updateSettings() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false

                this.$store.dispatch('company/updateConfiguration', {
                    key: this.settingKeys,
                    text_value,
                    bool_value,
                })
                this.doToast('Success!', 'Settings Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        addFrequency: function ({ name, value }) {
            console.log('model', this.model)
            if (
                name &&
                value &&
                !this.model.frequencies.some(x => x.name === name) &&
                value >= 1 &&
                value <= 365
            ) {
                this.model.frequencies.push({
                    name,
                    value,
                })
                this.$nextTick(() => {
                    this.updateSettings()
                })
            } else {
                this.doToast('Error!', 'Invalid Entry', 'danger')
            }
        },

        deleteNote: function (index) {
            console.log('>> ', index)
            this.model.frequencies.splice(index, 1)
            this.$nextTick(() => {
                this.updateSettings()
            })
        },
    },
}
</script>
